import FieldValidationCodes from '@/lib/fieldValidationCodes';
import Validator from '@/lib/validator';
import GiganautVue from '@/components/Shared/GiganautVue';

export default class GiganautVueForm extends GiganautVue {
  public FieldValidationCodes = FieldValidationCodes;
  public validate(field: string, otherField: any) {
    return Validator.forField(field, otherField);
  }
  public valid = true;
}
